<template lang="pug">
.container
  .announcement-wrapper
    .container-fluid
      .announcement-content
        .announcement-left
          i.fa-solid.fa-bell
          span {{ $t('ui.notice') }}
        .announcement-right.flex-grow-1
          marquee(behavior='scroll' direction='left' scrollamount='5') Welcome to the largest and trusted online casino!  
        .datetime {{ currentTime }}
        //- .inbox
        //-   a(href='javascript:void(0);')
        //-     i.fa-solid.fa-envelope
        //-     .inbox-number 5
</template>

<script>
export default{
  data() {
    return {
      currentTime: null
    }
  },
  created: function() {
    this.currentTime = this.$moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss") + " " + this.$moment().format("A")
    setInterval(() =>
      this.updateCurrentTime(), 1 * 1000
    )
  },
  beforeDestroy () {
    clearInterval(this.updateCurrentTime())
  },
  methods:{
    updateCurrentTime: function() {
      this.currentTime = this.$moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss") + " " + this.$moment().format("A")
    }
  }
}
</script>